import SearchAddressView from "../views/SearchAddressView.vue";

export const SearchAddressRouters = [
    {
        path: "/searchAddress/:deviceOs",
        name: "SearchAddressView",
        components: {
            default: SearchAddressView,
        },
        props: {
            default: true
        },
    },
];
